import { readLooseAppManifest } from '@wix/cli-app-manifest';
import { readBuildManifest } from '../files/build.config.js';

export async function readAppManifestFile(projectFolder: string) {
  const buildManifest = await readBuildManifest(projectFolder);
  return readLooseAppManifest(buildManifest.appManifestPath);
}
